export default __webpack_public_path__ + "static/media/RU_SIG_NJAES_PMS186_100K.f2e1beb2.svg";